// Libraries
import { Injectable } from '@angular/core';
// Setting configuration
import { SETTINGS } from '../models/Setting';
// Lodash
import * as _ from 'lodash';

@Injectable()
export class SettingService {

	/**
	 * Find in the setting list the setting that has 
	 * the id matched with settingId input
	 * @param {string} settingId - the id of the setting
	 * @return {string} - the setting value or empty string
	 */
	getSetting(settingId: string) {
		let result = _.find(SETTINGS, {'id': settingId});

		return result ? result.value : '';
	}
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/SettingService.ts